/* RESPONSIBLE TEAM: team-data-foundations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-controller-access-in-routes */
/* eslint-disable ember/no-classic-classes */
import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import MailchimpList from 'embercom/models/mailchimp-list';

export default Route.extend({
  store: service(),
  appService: service(),
  analytics: {
    section: 'mailchimp_imports',
    place: 'lists',
  },

  activate() {
    this.controllerFor('apps/app/import/mailchimp').set('currentStep', 2);
  },

  model(params) {
    return this.store.findRecord('mailchimp-import', params.id);
  },

  async afterModel(mailchimpImport) {
    let lists = await MailchimpList.list(this.appService.app.id);
    return mailchimpImport.set('lists', lists);
  },
});
